import { render, staticRenderFns } from "./LogoIntroSection.vue?vue&type=template&id=501634a0"
import script from "./LogoIntroSection.vue?vue&type=script&lang=ts"
export * from "./LogoIntroSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoIntroSection.vue?vue&type=style&index=0&id=501634a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports